import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'

import { MOCK_NOTIFICATIONS } from '../const/mock-notifications.const'
import type { Notification } from '../types/notification.type'

type NotificationsStore = {
  notifications: Notification[]
  markAsRead: (id: string) => void
  markAllAsRead: () => void
  dismissNotification: (id: string) => void
  clearAll: () => void
}

export const useNotificationsStore = create<NotificationsStore>()(
  devtools(
    immer((set) => ({
      notifications: MOCK_NOTIFICATIONS,
      markAsRead: (id) =>
        set((state) => {
          const notification = state.notifications.find((item) => item.id === id)
          if (notification) {
            notification.isRead = true
          }
        }),
      markAllAsRead: () =>
        set((state) => {
          state.notifications.forEach((notification) => {
            notification.isRead = true
          })
        }),
      dismissNotification: (id) =>
        set((state) => {
          state.notifications = state.notifications.filter((notification) => notification.id !== id)
        }),
      clearAll: () =>
        set((state) => {
          state.notifications = []
        }),
    })),
    { name: 'NotificationsStore', enabled: process.env.NODE_ENV === 'development' }
  )
)
